// removed by extract-text-webpack-plugin
module.exports = {"customer-step":"customer-step__y8E_f","account-options-wrapper":"account-options-wrapper__14zry","desc-wrapper":"desc-wrapper__3oLJD","gender-options-wrapper":"gender-options-wrapper__3i4Vn","delivery-information":"delivery-information__276R3","accordion":"accordion__2pbAm","title":"title__1CPCU","edit":"edit__3j-Cd","arrow-down":"arrow-down__2FLMk","check":"check__3oyyX","visible":"visible__3rl3_","country":"country__FVHrd","label":"label__3ht21","required":"required__3IuHj","consent":"consent__29l5i","consents":"consents__3xatr","birthday-msg-wrapper":"birthday-msg-wrapper__2Dgrd"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/raffleForm/styles/CustomerStep.scss
// module id = XCI4
// module chunks = 1